export const PHARMACY_GET_REQUESTED = 'PHARMACY_GET_REQUESTED';
export const PHARMACY_GET_SUCCEED = 'PHARMACY_GET_SUCCEED';
export const PHARMACY_GET_FAILED = 'PHARMACY_GET_FAILED';
